import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy } from '@angular/core';
import { Config } from '../../config/config';
import { RestDataService } from '../../service/rest-data.service';
import { EmbedVideoService } from 'ngx-embed-video';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { AngularCropperjsComponent } from 'angular-cropperjs';
import { of } from 'rxjs';
@Component({
  selector: '.image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.css']
})
export class ImageCropperComponent implements OnInit, OnDestroy {

  @Input() cropperImageUrl: any;
  @Input() bannerCrop : any;
  @Input() imageBlob: any;
  @Input() isImageLead = false;
  @Input() isHowToStepsImage = false;
  @Input() isProductImage = false;
  @Input() isMicrositeImage = false;
  @Input() addVideoThumbnail = false;
  @Input() verticalImageFlag = false;
  @Input() thumborCompressed = 'false';
  @Input() liveblogCropper = false;
  @Input() storyType = '';
  @Input() liveblogImage = false;
  showLeadMediaCropper: boolean = false;
  pageTypeInput: any;
  @Input()
  set profileCropper(profileCrop: boolean) {
    this.showProfileCropper = (profileCrop) ? profileCrop : null;
  }
  @Input()
  set leadVideoCropper(vidImgCrop: boolean) {
    this.showLeadMediaCropper = (vidImgCrop) ? vidImgCrop : null;
  }

  @Input()
  set pageType(pageType: any) {
    this.pageTypeInput = (pageType) ? pageType : null;
    console.log(this.pageTypeInput)
  }
  @Input() leadMediaImageGif: boolean;
  @Output() finish = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Input() explicitCropperUrls: any[];
  @Input() ogImage: any;
  @Input() parentId;

  @ViewChild('angularCropper169', {static: false}) public angularCropper169: AngularCropperjsComponent;
  @ViewChild('angularCropper11',{static: false}) public angularCropper11: AngularCropperjsComponent;
  @ViewChild('angularCropper23',{static: false}) public angularCropper23: AngularCropperjsComponent;
  @ViewChild('angularCropper21',{static: false}) public angularCropper21: AngularCropperjsComponent;
  @ViewChild('angularCropper45',{static: false}) public angularCropper45: AngularCropperjsComponent;
  @ViewChild('angularCropper43',{static: false}) public angularCropper43: AngularCropperjsComponent;
  @ViewChild('angularCropper916',{static: false}) public angularCropper916: AngularCropperjsComponent;
  cropperConfig169 = {
    aspectRatio: 16 / 9,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  cropperConfig11 = {
    aspectRatio: 1 / 1,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };

  cropperConfig23 = {
    aspectRatio: 2 / 3,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };

  cropperConfig21 = {
    aspectRatio: 2 / 1,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };

  cropperConfig45 = {
    aspectRatio: 4 / 5,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  cropperConfig43 = {
    aspectRatio: 4 / 3,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  cropperConfig916 = {
    aspectRatio: 9 / 16,
    cropBoxResizable: false,
    cropBoxMovable: false,
    dragMode: 'move',
    viewMode: 1,
    toggleDragModeOnDblClick: false,
    autoCropArea: 0,
    movable: true,
    scalable: true,
    zoomable: true
  };
  initZoom169 = 2;
  initZoom11 = 2;
  initZoom23 = 2;
  initZoom21 = 2;
  initZoom45 = 2;
  initZoom43 = 2;
  initZoom916 = 2;
  cropperToShow;
  domainConfig;
  showLeadToggle = false;
  leadMediaImageToggle = false;
  isLightbox = false;
  isMultipleLeadImageAllowed = false;
  reloadEl = true;
  lastCropperUrl = null;
  showProfileCropper: boolean = false;
  imageFileName ='';
  currentImageFileName ='';
  currentImageExtension='';
  accessImageUrl='';
  imageFile:any;
  editLeadImageName = false;
  pickFromLibrary = false;
  ogRatios=[];
  constructor(
    public config: Config,
    public restService: RestDataService,
    private embedService: EmbedVideoService,
    private http: HttpClient,
    private snotify: SnotifyService,
    private sharedService: SharedDataService
  ) { }

  ngOnInit() {
    this.sharedService.overflowhidden();
    this.domainConfig = this.sharedService.currentDomainConfiguration;
    this.cropperToShow = (this.domainConfig['imageRatios'] && (this.domainConfig['imageRatios'].length > 0))
      ? this.domainConfig['imageRatios'] : StaticDataService.defaultConfig.imageRatios;
    this.showLeadToggle = (this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['leadPreference'] === 'true');
    this.isMultipleLeadImageAllowed = (this.domainConfig && this.domainConfig['config']
    && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['multipleLeadImage'] === 'true');
    this.lastCropperUrl = this.cropperImageUrl;
    if(this.showProfileCropper === true){
      this.cropperToShow=["16:9","1:1"];
    }
    if(this.liveblogCropper) {
      this.cropperToShow=["16:9"]
    }
    if(this.verticalImageFlag) {
      this.cropperToShow.push("9:16");
    }
    //if(this.domainConfig['config']['image'] && this.domainConfig['config']['image']['editLeadImageName'] === 'true' && this.storyType && this.storyType == 'story')
    if(this.domainConfig['config']['image'] && this.domainConfig['config']['image']['editLeadImageName'] === 'true')
    {
      this.editLeadImageName = true;
    }
    // if(this.showLeadMediaCropper){
    //   this.cropperToShow = ["16:9", "1:1"];
    // }

    if(this.isHowToStepsImage) {
      if(this.domainConfig['config'] && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['cropperImageRatios'])
        this.cropperToShow=this.domainConfig['config']['image']['cropperImageRatios'].split(",");
      else
        this.cropperToShow=["1:1"];
      // console.log("cropperImageRatios :: ", this.domainConfig['config']['image']['cropperImageRatios'].split(","));
    }
    if(this.isProductImage) {
      this.cropperToShow = ["1:1", "16:9"];
    }
    if(this.isMicrositeImage) {
      this.cropperToShow = ["1:1"];
    }
    if(this.liveblogImage) {
      this.cropperToShow=["16:9"];
    }
    if(this.bannerCrop) {
      this.cropperToShow = ["2:1"]
    }
    if(this.storyType && this.storyType =='web-story')
    {
      if(this.cropperToShow && this.cropperToShow.length>0)
      {
        this.cropperToShow.push("9:16");
      }
      else{
        this.cropperToShow = ["9:16"]
      }
    }

    if(this.explicitCropperUrls && this.explicitCropperUrls.length>0)
    {
      this.cropperToShow = this.explicitCropperUrls;
    }

    if(this.ogImage)
    {
      if((this.domainConfig['config'] && this.domainConfig['config']['image'] && this.domainConfig['config']['image']['ogRatios']))
      {
        this.ogRatios = ((this.domainConfig['config']['image']['ogRatios'])+"").split(',');
      }else{
        this.ogRatios =  StaticDataService.defaultConfig.imageRatios;
      }
      this.cropperToShow = [this.ogRatios[0]];
    }
  }

  changeOGRatio(item)
  {
    this.cropperToShow = [item];
  }

  ngOnChanges()
  {
    if(this.cropperImageUrl && this.cropperImageUrl.url)
    {
      this.currentImageFileName = this.cropperImageUrl.url.substring(this.cropperImageUrl.url.lastIndexOf("/")+1,this.cropperImageUrl.url.lastIndexOf("_")>this.cropperImageUrl.url.lastIndexOf("/")?this.cropperImageUrl.url.lastIndexOf("_"):this.cropperImageUrl.url.lastIndexOf("."));
      this.imageFileName = this.cropperImageUrl.url.substring(this.cropperImageUrl.url.lastIndexOf("/")+1,this.cropperImageUrl.url.lastIndexOf("_")>this.cropperImageUrl.url.lastIndexOf("/")?this.cropperImageUrl.url.lastIndexOf("_"):this.cropperImageUrl.url.lastIndexOf("."));
      this.currentImageExtension = this.cropperImageUrl.url.substring(this.cropperImageUrl.url.lastIndexOf("."),this.cropperImageUrl.url.length);
      this.accessImageUrl=(this.cropperImageUrl.url.indexOf(StaticDataService.proxyImage)>-1) ? this.cropperImageUrl.url : this.config.get('product').baseUrl + StaticDataService.proxyImage + this.cropperImageUrl.url;
      this.pickFromLibrary = (this.cropperImageUrl.url.indexOf(StaticDataService.proxyImage)>-1) ? true : false;
    }
  }

  ngDoCheck()
  {
    if(this.currentImageFileName == '' && this.cropperImageUrl && this.cropperImageUrl.url)
    {
      this.currentImageFileName = this.cropperImageUrl.url.substring(this.cropperImageUrl.url.lastIndexOf("/")+1,this.cropperImageUrl.url.lastIndexOf("_")>this.cropperImageUrl.url.lastIndexOf("/")?this.cropperImageUrl.url.lastIndexOf("_"):this.cropperImageUrl.url.lastIndexOf("."));
      this.imageFileName = this.cropperImageUrl.url.substring(this.cropperImageUrl.url.lastIndexOf("/")+1,this.cropperImageUrl.url.lastIndexOf("_")>this.cropperImageUrl.url.lastIndexOf("/")?this.cropperImageUrl.url.lastIndexOf("_"):this.cropperImageUrl.url.lastIndexOf("."));
      this.currentImageExtension = this.cropperImageUrl.url.substring(this.cropperImageUrl.url.lastIndexOf("."),this.cropperImageUrl.url.length);
      this.accessImageUrl=(this.cropperImageUrl.url.indexOf(StaticDataService.proxyImage)>-1) ? this.cropperImageUrl.url : this.config.get('product').baseUrl + StaticDataService.proxyImage + this.cropperImageUrl.url;
      this.pickFromLibrary = (this.cropperImageUrl.url.indexOf(StaticDataService.proxyImage)>-1) ? true : false;
    }
  }

  zoomSlider(x, img) {
    // console.log(x);
    if (this.angularCropper11 || this.angularCropper169 || this.angularCropper23 || this.angularCropper45 || this.angularCropper43 || this.angularCropper916) {
      if (img === '16:9') {
        // console.log(+x, this.initZoom169);
        // console.log(+x > this.initZoom169);
        if (+x > this.initZoom169) {
          this.angularCropper169.cropper.zoom(0.1);
          this.initZoom169 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper169.cropper.zoom(-0.1);
          this.initZoom169 = +x;
          // console.log('zoom out');
        }
      } else if (img === '1:1') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom11) {
          this.angularCropper11.cropper.zoom(0.1);
          this.initZoom11 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper11.cropper.zoom(-0.1);
          this.initZoom11 = +x;
          // console.log('zoom out');
        }
      } else if (img === '2:3') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom23) {
          this.angularCropper23.cropper.zoom(0.1);
          this.initZoom23 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper23.cropper.zoom(-0.1);
          this.initZoom23 = +x;
          // console.log('zoom out');
        }
      }else if (img === '2:1') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom21) {
          this.angularCropper21.cropper.zoom(0.1);
          this.initZoom21 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper21.cropper.zoom(-0.1);
          this.initZoom21 = +x;
          // console.log('zoom out');
        }
      } else if (img === '4:5') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom45) {
          this.angularCropper45.cropper.zoom(0.1);
          this.initZoom45 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper45.cropper.zoom(-0.1);
          this.initZoom45 = +x;
          // console.log('zoom out');
        }
      }
      else if (img === '4:3') {
        // console.log(this.initZoom11);
        if (+x > this.initZoom43) {
          this.angularCropper43.cropper.zoom(0.1);
          this.initZoom43 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper43.cropper.zoom(-0.1);
          this.initZoom43 = +x;
          // console.log('zoom out');
        }
      }
      else if (img === '9:16') {
        // console.log(+x, this.initZoom169);
        // console.log(+x > this.initZoom169);
        if (+x > this.initZoom916) {
          this.angularCropper916.cropper.zoom(0.1);
          this.initZoom916 = +x;
          // console.log('zoom in');
        } else {
          this.angularCropper916.cropper.zoom(-0.1);
          this.initZoom916 = +x;
          // console.log('zoom out');
        }
      } 
    }
  }

  createCroppingRequest(imageDate:any): any {
    return (this.http.post(this.config.get('product').imageUploadUrl
    + this.config.get('product').imageCropByUrlEndPoint + (this.pageTypeInput === 'BRUNCH' ? '?optimizeReq=true' : ''), imageDate))
  }
  

  createCroppingData(cropperData,ratio): any {
    const a = cropperData.cropper.getData(true);
      var cropperData:any = {};
      cropperData.x=a.x;
      cropperData.y=a.y;
      cropperData.w=a.width;
      cropperData.h=a.height; 
      cropperData.r=ratio;
      return cropperData;
  }

  startCropping() {
    if (!this.checkSpecialChars()) {
      if (this.currentImageFileName && this.currentImageFileName != ''
      && this.imageFileName && this.imageFileName != '' && this.imageFileName !== this.currentImageFileName && this.editLeadImageName) {
      this.sharedService.getImage(this.accessImageUrl).subscribe((data) => {
        this.imageFile = new File([data], this.imageFileName+this.currentImageExtension);
        this.sharedService.uploadImage(this.imageFile).subscribe(res => {
            if(!this.pickFromLibrary)
            {
              let previousImageUrl = this.cropperImageUrl.url
              this.sharedService.deletePreviousImage(previousImageUrl).subscribe(data =>{
              },
              error => {
                this.snotify.error('Failed to delete previous uploaded image', '', this.sharedService.getConfig(false));
              });
            }
            let currentImageUrl = this.cropperImageUrl.url;
            currentImageUrl = currentImageUrl.replace(this.config.get('product').baseUrl + StaticDataService.proxyImage, '');
            this.cropperImageUrl.url = this.cropperImageUrl.url.replace(currentImageUrl, res['images']['original']);
            if (this.cropperImageUrl.hasOwnProperty('blobData')
              && this.cropperImageUrl.blobData && this.cropperImageUrl.blobData !== null) {
              this.uploadSequence();
            } else {
              this.finishCropping();
            }
          },
            error => {
              this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
            });
      });
    } else {
      if (this.cropperImageUrl.hasOwnProperty('blobData')
        && this.cropperImageUrl.blobData && this.cropperImageUrl.blobData !== null) {
        this.uploadSequence();
      } else {
        this.finishCropping();
      }
    }
    }
  }

  uploadSequence() {
    const fd = new FormData();
    fd.append('file', this.cropperImageUrl.blobData, this.cropperImageUrl.blobData.name);
    this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadEndPoint, fd).
      subscribe(res => {
        this.cropperImageUrl.url = res['images']['original'];
        this.finishCropping();
      });
  }

  finishCropping() {
    let url = this.cropperImageUrl.url;
    let url2 = this.isSecondImagePresent() ? this.cropperImageUrl.url2 : url;
    const verticalFlag = this.verticalImageFlag;
    this.snotify.info('Cropping...', '', this.sharedService.getConfig(false));

    url = url.replace(this.config.get('product').baseUrl + StaticDataService.proxyImage, '');
    url2 = url2.replace(this.config.get('product').baseUrl + StaticDataService.proxyImage, '');
    var cropRequests:any=[];
    
    var imageDetailforUrl:any={};
    imageDetailforUrl.imageCroppingDetail=[];
    imageDetailforUrl.imageUrl=url;
    var imageDetailforUrl2:any={};
    imageDetailforUrl2.imageCroppingDetail=[];
    imageDetailforUrl2.imageUrl=url2;
    
    if(this.ogImage)
    {
      imageDetailforUrl.ogImage=this.ogImage;
      imageDetailforUrl2.ogImage=this.ogImage;
    }
    if(this.sharedService.isdomainConfig('story','thumborCompressed')) {
      imageDetailforUrl.thumborCompressed=this.thumborCompressed;
      imageDetailforUrl2.thumborCompressed=this.thumborCompressed;
    }
    
    
    (this.cropperToShow.indexOf('16:9') > -1)? imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData(this.angularCropper169,"16:9")):of(null);
    if(this.cropperToShow.indexOf('1:1') > -1){
    if(url!=url2){
      imageDetailforUrl2.imageCroppingDetail.push(this.createCroppingData(this.angularCropper11,"1:1"));
      cropRequests.push(this.createCroppingRequest(imageDetailforUrl2));
    }else{
            imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData(this.angularCropper11,"1:1"));
       }
    }   
    (this.cropperToShow.indexOf('2:3') > -1) ? imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData(this.angularCropper23,"2:3")) : of(null);
    (this.cropperToShow.indexOf('2:1') > -1) ? imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData(this.angularCropper21,"2:1")) : of(null);
    (this.cropperToShow.indexOf('4:5') > -1) ? imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData( this.angularCropper45,"4:5")) : of(null);
    (this.cropperToShow.indexOf('4:3') > -1) ? imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData(this.angularCropper43,"4:3")) : of(null);
    (this.cropperToShow.indexOf('9:16') > -1) ? imageDetailforUrl.imageCroppingDetail.push(this.createCroppingData(this.angularCropper916,"9:16")) : of(null);
    
    cropRequests.push(this.createCroppingRequest(imageDetailforUrl));
    this.finish.emit({cropRequests, verticalFlag, differentImage: (url !== url2), parentId:this.parentId});
  }

  cancelCropping() {
    this.cancel.emit();
  }

  ngOnDestroy() {
    this.sharedService.overflowauto();
  }

  toggleSwitch(type) {
    this.verticalImageFlag = !this.verticalImageFlag;
  }

  showGallery() {
    this.isLightbox = true;
    this.sharedService.overflowhidden();
  }
  disableshowGallery() {
    this.isLightbox = false;
    this.leadMediaImageToggle = false;
    this.sharedService.overflowauto();
  }
  checkSpecialChars() {
    let regex = new RegExp(/[^a-zA-z0-9-_\s]+/g);
    let m;
      m = regex.exec(this.imageFileName);
      if (m) {
          this.imageFileName = this.imageFileName.replace(regex, '');
          this.snotify.error('Special Chars not Allowed', '', this.sharedService.getConfig(false));
          return true;
      }
    if(this.imageFileName.length > 50) {
      this.snotify.error('File Name should be less than 50 Charecters', '', this.sharedService.getConfig(false));
      this.imageFileName = this.imageFileName.slice(0,50);
      return true;
    }
    return false;
  }

  uploadAnotherImage(ev, methodType) {
    // console.log(ev, methodType);
    this.disableshowGallery();
    if (methodType === 'upload') {
      const reader = new FileReader();
      const SingleselectedFile = <File>event.target['files'][0];
      if (event.target['files'] && event.target['files'].length > 0) {
        if ((typeof event.target['files'][0]) === 'object') {
          // console.log(event.target.files[0]);
          if ((SingleselectedFile.size / 1000000) <= 11) {
            const a = reader.readAsDataURL(event.target['files'][0]);
            reader.onload = (e: any) => {
              this.uplaodImageAndOpenCropper(SingleselectedFile, e.target.result);
            };
          } else {
            this.snotify.error('Image size exceeds 12 MB', '', this.sharedService.getConfig(false));
          }
        }
      }
      event.target['value'] = null;
    } else if (methodType === 'pick') {
      if (ev.type === 'image') {
        const id = ev.id;
        this.restService.http_get(
          this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element')
          + '/' + id
        ).subscribe(result => {
          // console.log(result);
          const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage +
          result['image']['images']['original'];
          this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
            this.setSecondImageData(data.data, imageUrl);
          });
        });
      } else if (ev.type === 'wire') {
        const url = ev.id;
        const imageUrl = this.config.get('product').baseUrl + StaticDataService.proxyImage + url;
        this.sharedService.createObjectFromImageUrl(imageUrl, (data, reader) => {
          const fd = new FormData();
          fd.set('file', url);
          this.http.post(this.config.get('product').imageUploadUrl + this.config.get('product').imageUploadByUrlEndPoint, fd).
            subscribe(res => {
              this.setSecondImageData(data.data, res['images']['original']);
          });
        });
      }
    }
  }

  uplaodImageAndOpenCropper(imageFile, base64) {
    this.snotify.info('Uplaoding', '', this.sharedService.getConfig(false));
    this.sharedService.uploadImage(imageFile).
      subscribe(res => {
        this.setSecondImageData(base64, res['images']['original']);
      },
      error => {
        this.snotify.error('Upload Failed', '', this.sharedService.getConfig(false));
      });
  }

  setFirstImageData() {
    delete this.cropperImageUrl['data2'];
    delete this.cropperImageUrl['url2'];
    this.resetCropper();
  }

  setSecondImageData(base64, originalURL) {
    this.cropperImageUrl.data2 = base64;
    this.cropperImageUrl.url2 = originalURL;
    this.resetCropper();
  }

  resetCropper() {
    this.reloadEl = false;
    setTimeout(e => {this.reloadEl = true; }, 10);
  }

  isSecondImagePresent() {
    return (this.isMultipleLeadImageAllowed
      && this.cropperImageUrl && this.cropperImageUrl.data2 && this.cropperImageUrl.url2);
  }

  getImageSource() {
    if (this.isSecondImagePresent()) {
        return this.cropperImageUrl.data2;
    } else {
      return this.cropperImageUrl.data;
    }
  }

}
